import * as Yup from 'yup';
import { RetirementOptions } from '../RetirementPage.hooks';

export const INITIAL_VALUES: RetirementOptions = {
  totalAsset: 0,
  monthlyExpense: 3_000_000,
  annualReturnRate: 3.5,
  retirementAge: 60,
};

export const schema = Yup.object().shape({
  totalAsset: Yup.number().required('필수 입력 항목입니다.').min(1, '1원 이상 입력해주세요'),
  monthlyExpense: Yup.number().required('필수 입력 항목입니다.').min(1, '1원 이상 입력해주세요'),
  annualReturnRate: Yup.number()
    .required('필수 입력 항목입니다.')
    .min(0, '0% 이상을 입력해 주세요.')
    .max(50, '수익률은 50% 이하로 입력해 주세요.'),
  retirementAge: Yup.number()
    .required('필수 입력 항목입니다.')
    .min(40, '40세 이상 입력해주세요')
    .max(80, '80세 이하로 입력해주세요'),
});
